// extracted by mini-css-extract-plugin
module.exports = {"sk_row":"AppSkeleton_sk_row__3ffix","sk_col":"AppSkeleton_sk_col__2K0Cy","sk_header":"AppSkeleton_sk_header__24-uO","sk-animation":"AppSkeleton_sk-animation__18wZR"};